import isEmpty from "lodash/isEmpty";
import { SearchableVariant, SelectV2 } from "PFComponents/select_v2";
import { Typography } from "PFComponents/typography";
import { Id } from "PFTypes";
import { Option } from "PFTypes/options";
import React, { RefObject } from "react";

type WarningsFilterProps = {
  label: string;
  options: Option<Id>[];
  selectedOption: Id | null;
  onChangeSelectedOption: (value: Id) => void;
  sidePanelRef?: RefObject<HTMLDivElement | null>;
};

export const WarningsFilter = ({
  label,
  options,
  selectedOption,
  onChangeSelectedOption,
  sidePanelRef
}: WarningsFilterProps) => {
  if (isEmpty(options) || !selectedOption) {
    return null;
  }

  if (options.length === 1) {
    return (
      <Typography withMargin variant="bodyBold" tag="span">
        {options[0].value}
      </Typography>
    );
  }

  return (
    <SelectV2<Id>
      label={label}
      value={selectedOption}
      onChange={(option: Option<Id>) => onChangeSelectedOption(option.id)}
      options={options}
      searchableVariant={SearchableVariant.Never}
      portalRef={sidePanelRef}
    />
  );
};
